export function Authenticated ({ next, store, to }) {
  if (!store.getters['auth/isSignIn']) {
    return next({
      name: 'auth.signin'
    })
  }
  return next({ next, store, to })
}

export function Guest ({ next, store, to }) {
  if (store.getters['auth/isSignIn']) {
    return next({
      name: 'cpanel'
    })
  }

  return next({ next, store, to })
}

export function middlewarePipeline (router, store) {
  function nextFactory (context, middleware, index) {
    const subsequentMiddleware = middleware[index]
    if (!subsequentMiddleware) return context.next

    return (...parameters) => {
      context.next(...parameters)
      const nextMiddleware = nextFactory(context, middleware, index + 1)
      subsequentMiddleware({ ...context, next: nextMiddleware })
    }
  }

  router.beforeEach(async (to, from, next) => {
    if (store.getters['auth/isSignIn'] && !store.getters['auth/profile']) {
      try {
        await store.dispatch('auth/GET_PROFILE')
      } catch (e) {
      }
    }

    let routeMiddleware = to.meta.middleware
    if (!routeMiddleware && to.matched.length > 0 && to.matched[0].meta) {
      routeMiddleware = to.matched[0].meta.middleware
    }

    if (routeMiddleware) {
      const middleware = Array.isArray(routeMiddleware)
        ? routeMiddleware
        : [routeMiddleware]
      const context = {
        from,
        next,
        router,
        to
      }
      const nextMiddleware = nextFactory(context, middleware, 1)
      return middleware[0]({ ...context, store, next: nextMiddleware, to: to })
    }

    return next()
  })
}
